import { IPaginationData } from "@faire/web-api/indigofair/data/IPaginationData";

import { useCategoryPageQuery } from "@faire/retailer/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageQuery/useCategoryPageQuery";

export const useCategoryPagePaginationData = ():
  | IPaginationData
  | undefined => {
  return useCategoryPageQuery().data?.pagination_data;
};
